import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export interface IProcessingProps {
    title: string;
}

const Processing = (props: IProcessingProps) => {
    const { title } = props;
    return (
        <div className='processing'>
            <Spin
                styles={{
                    root: {
                        width: 1024,
                        backgroundColor: 'rgba(0, 0, 0, 0.35)',
                        borderRadius: 10,
                        padding: 150,
                    },
                    description: {
                        fontSize: 18,
                        textShadow: 'none',
                    },
                }}
                description={title}
                indicator={<LoadingOutlined spin />}
                size='large'
            >
                <div className='processing-area'></div>
            </Spin>
        </div>
    );
};

export default Processing;
